import { render, staticRenderFns } from "./fs-popper-event-wrapper.vue?vue&type=template&id=ff5e3c9e"
import script from "./fs-popper-event-wrapper.vue?vue&type=script&lang=js"
export * from "./fs-popper-event-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff5e3c9e')) {
      api.createRecord('ff5e3c9e', component.options)
    } else {
      api.reload('ff5e3c9e', component.options)
    }
    module.hot.accept("./fs-popper-event-wrapper.vue?vue&type=template&id=ff5e3c9e", function () {
      api.rerender('ff5e3c9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/poppers/fs-popper-event-wrapper.vue"
export default component.exports